import * as React from "react";

function SvgClockTime(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g id="time" transform="translate(-3 -3)">
        <path
          id="Path_43731"
          data-name="Path 43731"
          d="M13.5,10.5h2.2V16h5.5v2.2H13.5Z"
          transform="translate(-1.723 -1.231)"
          fill="#039be5"
        />
        <path
          id="Path_43732"
          data-name="Path 43732"
          d="M27,15A12,12,0,1,1,15,3,12,12,0,0,1,27,15Zm-2.4,0A9.6,9.6,0,1,1,15,5.4,9.6,9.6,0,0,1,24.6,15Z"
          transform="translate(0 0)"
          fill="#039be5"
          fill-rule="evenodd"
        />
      </g>
    </svg>
  );
}

export default SvgClockTime;
